import { useTranslation } from "react-i18next";
import CommonStyles from "..";
import { EAppointmentStatus } from "@base/enums";
import { getStatusStyle } from "@base/modules/appointment/appointmentDetailRules";

interface IProps {
  status: EAppointmentStatus;
}

/** The appointment status pill, coloured as on the apps. */
export default function TagAppointmentStatus({ status }: IProps) {
  const { t } = useTranslation();
  const style = getStatusStyle(status);

  return (
    <div>
      <CommonStyles.TagUI
        tagName={style.labelKey ? t(style.labelKey) : status}
        // A pill, as on mobile.
        className="!rounded-full border-none !px-2.5 !py-0 !m-0 text-xs leading-5 font-medium"
        style={{ color: style.text, backgroundColor: style.background }}
      />
    </div>
  );
}
